import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import EmailScreen from '@nykaa/auth/components/Welcome/EmailLogin';
import { SUBTITLES, TOAST_TIMER } from '@nykaa/auth-shared/constants';
import Toast, { VARIANT } from '@nykaa/ui-components/Toast';
import useAuthData from '@nykaa/auth-shared/hooks/useAuthData';
import { WelcomeScreenProps } from '@nykaa/auth-shared/types';
import { handleSocialLogin } from '@nykaa/auth-shared/utils';
import useEmailSuggestion from '../../../hooks/emailSuggestion';
import { State } from 'store/types';
import { loginPageName } from 'components/SignUp/helper';
import { getLogin, useManageEvents } from '../helpers';

const EmailLogin = ({
  showNudge,
  switchBtnCallback,
  hideSocialLogin,
}: WelcomeScreenProps) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [isError, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const { loading, message, email, isApiError } = useAuthData();
  const isCheckExistenceCaptchaEnabled = useSelector(
    (state: State) =>
      state.remoteConfig.configs.configFlags.checkExistenceCaptcha
  );
  const { emailSuggestionList = {} } = useEmailSuggestion();

  useManageEvents(showNudge);

  const handleLogin = useCallback(
    (emailPhone: string) => {
      getLogin({
        emailPhone,
        history,
        dispatch,
        setErrorMessage,
        setError,
        isCheckExistenceCaptchaEnabled,
      });
    },
    [dispatch, history, isCheckExistenceCaptchaEnabled]
  );

  return (
    <>
      <EmailScreen
        subTitle={SUBTITLES.welcomeScreen}
        handleLogin={handleLogin}
        handleSocialLogin={handleSocialLogin}
        switchBtnCallback={switchBtnCallback}
        emailSuggestionList={emailSuggestionList}
        isLoading={loading}
        initialValue={email}
        isNudge={showNudge}
        loginPage={loginPageName()}
        hideSocialLogin={hideSocialLogin}
      />
      {(isError || isApiError) && (
        <Toast
          timer={TOAST_TIMER}
          variant={VARIANT.single}
          message={errorMessage || message}
        />
      )}
    </>
  );
};

export default EmailLogin;
